// Email popup
(function () {
  const backdrop   = document.getElementById('epop-backdrop');
  const closeBtn   = document.getElementById('epop-close');
  const panelForm  = document.getElementById('epop-panel-form');
  const panelWin   = document.getElementById('epop-panel-success');
  const copyBtn    = document.getElementById('epop-copy');
  const form       = document.getElementById('EmailPopupForm');
  const PROMO      = 'WELCOME10';

  if (!backdrop) return;

  function openPopup() {
    backdrop.classList.add('open');
    backdrop.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    backdrop.classList.remove('open');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem('hc_popup_seen', '1');
  }
  function showSuccess() {
    panelForm.hidden = true;
    panelWin.hidden  = false;
    localStorage.setItem('hc_popup_seen', '1');
  }

  if (!localStorage.getItem('hc_popup_seen')) {
    setTimeout(openPopup, 3000);
  }

  closeBtn && closeBtn.addEventListener('click', closePopup);
  backdrop.addEventListener('click', e => { if (e.target === backdrop) closePopup(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePopup(); });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const emailInput = form.querySelector('[type="email"]');
      if (!emailInput || !emailInput.validity.valid) { emailInput && emailInput.reportValidity(); return; }
      // Subscribe in the background
      fetch('/', { method: 'POST', body: new FormData(form) }).catch(() => {});
      showSuccess();
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(PROMO).then(() => {
        copyBtn.textContent = 'Copied!';
        setTimeout(() => { copyBtn.textContent = 'Copy'; }, 2000);
      }).catch(() => {
        copyBtn.textContent = PROMO;
      });
    });
  }
})();

// Cart discount code
(function () {
  const input   = document.getElementById('cart-discount-input');
  const applyBtn = document.getElementById('cart-discount-apply');
  const msg     = document.getElementById('cart-discount-msg');
  if (!applyBtn || !input) return;

  function apply() {
    const code = input.value.trim().toUpperCase();
    if (!code) { msg.textContent = 'Please enter a promo code.'; msg.className = 'cart-discount-msg error'; return; }
    msg.textContent = 'Applying...';
    msg.className = 'cart-discount-msg';
    // /discount/CODE applies the discount via cookie, then redirects to checkout
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  applyBtn.addEventListener('click', apply);
  input.addEventListener('keydown', e => { if (e.key === 'Enter') apply(); });
})();

// Mobile nav hamburger
const hamburger = document.getElementById('nav-hamburger');
const mobileMenu = document.getElementById('nav-mobile-menu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    hamburger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  mobileMenu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      hamburger.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}

// Cursor glow
const glow = document.getElementById('cursor-glow');
if (glow) {
  document.addEventListener('mousemove', e => {
    glow.style.left = e.clientX + 'px';
    glow.style.top  = e.clientY + 'px';
  });
}

// Nav scroll effect
const nav = document.querySelector('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const ro = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.08 });
  reveals.forEach(el => ro.observe(el));
}

// Animated counter
const counters = document.querySelectorAll('[data-count]');
if (counters.length) {
  const co = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseInt(el.dataset.count);
      let n = 0;
      const step = target / 70;
      const t = setInterval(() => {
        n += step;
        if (n >= target) { el.textContent = target.toLocaleString() + '+'; clearInterval(t); }
        else el.textContent = Math.floor(n).toLocaleString();
      }, 16);
      co.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(el => co.observe(el));
}

// ── CART UTILS ──
function fetchCart() {
  return fetch('/cart.js').then(r => r.json());
}

function updateCartCount() {
  fetchCart().then(cart => {
    document.querySelectorAll('.cart-count, .nav-cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
    });
  });
}

function addToCartAPI(variantId, btn, quantity) {
  if (!variantId) return;
  btn.disabled = true;
  const orig = btn.textContent;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
  })
  .then(r => r.json())
  .then(data => {
    if (data.status) throw new Error(data.description);
    btn.textContent = '✓ Added to Cart!';
    btn.classList.add('added');
    updateCartCount();
    setTimeout(() => {
      btn.textContent = orig;
      btn.classList.remove('added');
      btn.disabled = false;
    }, 2400);
  })
  .catch(err => {
    btn.textContent = 'Error — try again';
    btn.disabled = false;
    setTimeout(() => { btn.textContent = orig; }, 2400);
    console.error('Cart error:', err);
  });
}

// ── PRODUCT MODAL ──
let activeProd = null;
let activeIdx  = 0;

const backdrop  = document.getElementById('modal-backdrop');
const mainImg   = document.getElementById('modal-main-img');
const thumbWrap = document.getElementById('modal-thumbs');
const counter   = document.getElementById('modal-counter');

function openProduct(el) {
  try {
    activeProd = {
      eyebrow: el.dataset.eyebrow || '',
      name:    el.dataset.title   || '',
      price:   el.dataset.price   || '',
      variant: el.dataset.variant || '',
      desc:    el.dataset.desc    || '',
      images:  JSON.parse(el.dataset.images || '[]')
    };
  } catch(e) { return; }

  if (!activeProd.images.length) return;
  activeIdx = 0;

  document.getElementById('modal-eyebrow').textContent = activeProd.eyebrow;
  document.getElementById('modal-name').textContent    = activeProd.name;
  document.getElementById('modal-price').textContent   = activeProd.price;
  document.getElementById('modal-desc').textContent    = activeProd.desc;

  resetQty();
  renderModalGallery();
  backdrop.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function renderModalGallery() {
  mainImg.src = activeProd.images[activeIdx];
  mainImg.alt = activeProd.name;
  updateModalCounter();
  thumbWrap.innerHTML = '';
  activeProd.images.forEach((src, i) => {
    const t = document.createElement('div');
    t.className = 'modal-thumb' + (i === activeIdx ? ' active' : '');
    t.innerHTML = `<img src="${src}" alt="${activeProd.name} view ${i + 1}" loading="lazy" />`;
    t.addEventListener('click', ev => { ev.stopPropagation(); setModalImg(i); });
    thumbWrap.appendChild(t);
  });
}

function updateModalCounter() {
  if (counter) counter.textContent = (activeIdx + 1) + ' / ' + activeProd.images.length;
}

function setModalImg(idx) {
  mainImg.classList.add('fading');
  setTimeout(() => {
    activeIdx = idx;
    mainImg.src = activeProd.images[idx];
    mainImg.classList.remove('fading');
    updateModalCounter();
    thumbWrap.querySelectorAll('.modal-thumb').forEach((t, i) => t.classList.toggle('active', i === idx));
  }, 210);
}

function prevModalImg() { setModalImg((activeIdx - 1 + activeProd.images.length) % activeProd.images.length); }
function nextModalImg() { setModalImg((activeIdx + 1) % activeProd.images.length); }

function closeModal() {
  backdrop.classList.remove('open');
  document.body.style.overflow = '';
}

if (backdrop) {
  document.getElementById('modal-close').addEventListener('click', closeModal);
  document.getElementById('modal-prev').addEventListener('click', e => { e.stopPropagation(); prevModalImg(); });
  document.getElementById('modal-next').addEventListener('click', e => { e.stopPropagation(); nextModalImg(); });
  backdrop.addEventListener('click', e => { if (e.target === backdrop) closeModal(); });

  // Quantity selector
  const qtyNum = document.getElementById('modal-qty');
  const qtyDec = document.getElementById('modal-qty-dec');
  const qtyInc = document.getElementById('modal-qty-inc');
  function resetQty() { if (qtyNum) qtyNum.textContent = '1'; }
  if (qtyDec && qtyInc && qtyNum) {
    qtyDec.addEventListener('click', () => {
      const v = parseInt(qtyNum.textContent);
      if (v > 1) qtyNum.textContent = v - 1;
    });
    qtyInc.addEventListener('click', () => {
      const v = parseInt(qtyNum.textContent);
      if (v < 10) qtyNum.textContent = v + 1;
    });
  }

  const modalCtaBtn = document.getElementById('modal-cta');
  if (modalCtaBtn) {
    modalCtaBtn.addEventListener('click', () => {
      if (activeProd && activeProd.variant) {
        const qty = qtyNum ? parseInt(qtyNum.textContent) : 1;
        addToCartAPI(activeProd.variant, modalCtaBtn, qty);
      }
    });
  }

  // Keyboard
  document.addEventListener('keydown', e => {
    if (!backdrop.classList.contains('open')) return;
    if (e.key === 'Escape')     closeModal();
    if (e.key === 'ArrowLeft')  prevModalImg();
    if (e.key === 'ArrowRight') nextModalImg();
  });

  // Swipe
  let swipeX = 0;
  backdrop.addEventListener('touchstart', e => { swipeX = e.touches[0].clientX; }, { passive: true });
  backdrop.addEventListener('touchend',   e => {
    const dx = e.changedTouches[0].clientX - swipeX;
    if (Math.abs(dx) > 48) dx < 0 ? nextModalImg() : prevModalImg();
  }, { passive: true });
}

// ── PRODUCT PAGE GALLERY ──
const ppMain = document.getElementById('pp-main-img');
if (ppMain) {
  let ppIdx = 0;
  const ppImgs = JSON.parse(document.getElementById('pp-images-json').textContent || '[]');

  function setPPImg(idx) {
    ppMain.classList.add('fading');
    setTimeout(() => {
      ppIdx = idx;
      ppMain.src = ppImgs[idx];
      ppMain.classList.remove('fading');
      document.querySelectorAll('.pp-thumb').forEach((t, i) => t.classList.toggle('active', i === idx));
    }, 210);
  }

  document.getElementById('pp-prev').addEventListener('click', () => setPPImg((ppIdx - 1 + ppImgs.length) % ppImgs.length));
  document.getElementById('pp-next').addEventListener('click', () => setPPImg((ppIdx + 1) % ppImgs.length));

  document.querySelectorAll('.pp-thumb').forEach((t, i) => {
    t.addEventListener('click', () => setPPImg(i));
  });

  const ppCta = document.getElementById('pp-cta');
  if (ppCta) {
    ppCta.addEventListener('click', () => {
      const variantId = ppCta.dataset.variant;
      addToCartAPI(variantId, ppCta);
    });
  }
}

// ── NEWSLETTER ──
const nlForm = document.querySelector('.nl-form');
if (nlForm) {
  nlForm.addEventListener('submit', e => {
    e.preventDefault();
    const btn = nlForm.querySelector('.nl-btn');
    const input = nlForm.querySelector('.nl-input');
    btn.textContent = '✓ Subscribed!';
    input.value = '';
    setTimeout(() => { btn.textContent = 'Subscribe'; }, 3000);
  });
}

// Cart page qty + remove
document.querySelectorAll('.cart-remove-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const key = btn.dataset.key;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(() => location.reload());
  });
});

// Init cart count on page load
updateCartCount();
